import React, { useState, useEffect, useContext } from "react";
import { RootStoreContext } from "../store/rootStore";
import { observer } from "mobx-react-lite";
import { ICard } from "../models/card";


interface IProps {
  cardChosen: ICard;
  changeCard: Function;
  showFilters: boolean;
  setShowFilters: Function;
}
const CardFilters:React.FC<IProps> = observer(({cardChosen, changeCard, showFilters, setShowFilters}) => {

  const rootStore = useContext(RootStoreContext);
  const {cards, setMobileCardShown} = rootStore.cardsStore;
  const {subjects} = rootStore.subjectStore;
  const {allYearsByType} = rootStore.yearsStore;
  
  const [chosenSubject, setChosenSubject] = useState<number>();
  const [chosenYear, setChosenYear] = useState<number>();

  const selectSubject = (subject:number) => {
    setChosenSubject(subject);
  }
  const selectYear = (year) => {
    setChosenYear(year)
  }

  const updateCard = () => {
    const newCard = cards.find(x => x.subjectId === chosenSubject && x.formId === chosenYear);
    changeCard(newCard);
    setShowFilters(false);
    setMobileCardShown(2);
  }

  useEffect(() => {
    setChosenSubject(cardChosen.subjectId);
    setChosenYear(cardChosen.formId)
  }, [cardChosen]);
  
  if(!showFilters) return;


  return (
    <div className='filters__holder inline'>
      <div className={`filters shown`}>
        <div className='filters__inner'>
          <p className='filters__title'>Select a subject...</p>
          <div className='filters__groups buttons filters__subjects'>
            {subjects && subjects.map(subject => 
              <button key={subject.slug} onClick={() => selectSubject(subject.termTaxonomyId)}
                className={subject.termTaxonomyId === chosenSubject ? 'chosen' : ''}
              >{subject.name}</button>
            )}
          </div>

          <div className='filters__groups dropdown filters__subjects'>
            <select className='filters__subjects_dropdown' onChange={(e) => selectSubject(parseInt(e.currentTarget.value))}>
              <option value=''>Please select</option>
              {subjects && subjects.map(subject => 
                <option key={subject.slug} value={subject.termTaxonomyId}>{subject.name}</option>
              )}
            </select>
          </div>

          <p className='filters__title filters__title-years'>Select a year...</p>
          <div className='filters__groups filters__years'>
            {allYearsByType && allYearsByType.map(year => 
              <button key={year.slug} onClick={() => selectYear(year.termTaxonomyId)}
                className={year.termTaxonomyId === chosenYear ? 'year chosen' : 'year'}
              >{year.name}</button>
            )}
          </div>
          <button className='filters__hide-filters show-results' onClick={() => updateCard()}>Show card</button>
        </div>
      </div>
    </div>
  )
});

export default CardFilters;
